import { flexRender } from "@tanstack/react-table";
import { Fragment } from "react";
import { XStack, YStack, useMedia } from "tamagui";
import { XPDataTableList } from "./XPDataTableList.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
import { createElement } from "react";
const XPDataTable = props => {
  const {
    getHeaderGroups,
    getRowModel,
    getFooterGroups
  } = props.table;
  const media = useMedia();
  if (media["max-sm"] && !props.skipMobileList) {
    return /* @__PURE__ */jsx(XPDataTableList, {
      ...props
    });
  }
  return /* @__PURE__ */jsxs(YStack, {
    ...(props.tableContainerProps || {}),
    children: [/* @__PURE__ */jsx(YStack, {
      style: {
        position: "sticky",
        top: 0,
        zIndex: 2
      },
      children: getHeaderGroups().map(headerGroup => /* @__PURE__ */createElement(XStack, {
        ...(props.headerGroupProps || {}),
        key: headerGroup.id
      }, headerGroup.headers.map(header => header.isPlaceholder ? /* @__PURE__ */jsx(XStack, {}, header.id) : flexRender(header.column.columnDef.header, header.getContext()))))
    }), /* @__PURE__ */jsx(YStack, {
      children: getRowModel().rows.map(row => /* @__PURE__ */jsxs(Fragment, {
        children: [/* @__PURE__ */jsx(XStack, {
          ...(props.bodyRowProps || {}),
          children: row.getVisibleCells().map(cell => {
            return flexRender(cell.column.columnDef.cell, cell.getContext());
          })
        }), row.getIsExpanded() && props.renderSubComponent ? /* @__PURE__ */jsx(XStack, {
          width: "100%",
          children: props.renderSubComponent(row)
        }) : null]
      }, row.id))
    }), /* @__PURE__ */jsx(YStack, {
      children: getFooterGroups().map(footerGroup => /* @__PURE__ */jsx(XStack, {
        children: footerGroup.headers.map(header => /* @__PURE__ */jsx(XStack, {
          children: header.isPlaceholder ? null : flexRender(header.column.columnDef.footer, header.getContext())
        }, header.id))
      }, footerGroup.id))
    })]
  });
};
export { XPDataTable };
//# sourceMappingURL=XPDataTable.mjs.map
